// extracted by mini-css-extract-plugin
export default {"patient":"PatientInformation_styles_patient__Qz8Kg"};